// extracted by mini-css-extract-plugin
export default {"activeButton":"styles_activeButton__5yDPX","declineButton":"styles_declineButton__HMQJp"};